import { Components } from '@mui/material'

export function OverridedPopover(): Components {
  return {
    MuiPopover: {
      defaultProps: {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom',
        },
        transformOrigin: {
          horizontal: 'right',
          vertical: 'top',
        },
      },
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
  }
}
